import {
  compareAppVersions,
  isRNAppAtLeast,
  parseRNAppUserAgent,
  RN_APP_USER_AGENT_MIN_VERSION,
  RN_APP_USER_AGENT_PATTERN,
} from '../utils/rnAppUserAgent'

//@ts-ignore
export const isRNWebView = !!window.ReactNativeWebView

export {
  compareAppVersions,
  isRNAppAtLeast,
  parseRNAppUserAgent,
  RN_APP_USER_AGENT_MIN_VERSION,
  RN_APP_USER_AGENT_PATTERN,
}
export type { RNAppPlatform, RNAppUserAgentInfo } from '../utils/rnAppUserAgent'

/** URL waivers require link click on web and on RN builds that identify via user agent. */
export const shouldRequireUrlWaiverLinkClick = () => {
  if (!isRNWebView) {
    return true
  }

  return isRNAppAtLeast(RN_APP_USER_AGENT_MIN_VERSION)
}
